export default "__VITE_ASSET__f2e47f54__"